document.addEventListener('DOMContentLoaded', function () {
  function syncButtonStates() {
    document.querySelectorAll('.custom-facet-button').forEach(button => {
      const name = button.dataset.filterName;
      const value = button.dataset.filterValue;
      const input = document.querySelector(`input[name="${name}"][value="${value}"]`);
      button.classList.toggle('active', input && input.checked);
    });
  }

  // Handle filter buttons (clear others, apply one)
  document.querySelectorAll('.custom-facet-button').forEach(button => {
    button.addEventListener('click', () => {
      // Uncheck all filters first
      document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(input => {
        input.checked = false;
      });

      // Check selected filter
      const name = button.dataset.filterName;
      const value = button.dataset.filterValue;
      const input = document.querySelector(`input[name="${name}"][value="${value}"]`);

      if (input) {
        input.checked = true;
        const form = document.querySelector('#FacetFiltersForm');
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
        syncButtonStates();
      }
    });
  });

  // Handle clear all button
  document.querySelector('.clear-all-filters')?.addEventListener('click', () => {
    document.querySelectorAll('#FacetFiltersForm input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });
    const form = document.querySelector('#FacetFiltersForm');
    if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
    syncButtonStates();
  });

  document.addEventListener('shopify:section:load', syncButtonStates);
  syncButtonStates();
});

